import { AxiosResponse } from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCountriesSuccess,
  getCountriesFailure,
  getStatesFailure,
  getStatesSuccess,
} from "../features/country.slice";
import { countryType, stateType } from "../types/countrystate.types";
import { baseInstance } from "../../service/instance";
import { ENDPOINTS } from "../../service/api";
import { toastError } from "../../shared/util/toast.message";

function* getCountriesApi() {
  try {
    let res: AxiosResponse = yield call(
      baseInstance.get,
      ENDPOINTS?.COUNTRY
    );
    if (res.data.statuscode===200) {
      const validCountry = res.data.data.map((item: any) => {
        return { label: item.CountryName, value: item.CountryID };
      });
      yield put(getCountriesSuccess(validCountry));
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(getCountriesFailure(err));
  }
}

function* getStates(action: any) {
  const paramsAs: { [key: string]: string | number } = {
    countryid: action.payload,
  };
  try {
    let res: AxiosResponse = yield call(
      baseInstance.get,
      ENDPOINTS?.STATE,
      {
        params: paramsAs,
      }
    );
    if (res.data.statuscode===200) {
      // console.log("state", res.data)
      let states: stateType = res.data.data;
      yield put(getStatesSuccess(states));
    }
  } catch (error:any) {
    toastError(error.message)
    yield put(getStatesFailure(error));
  }
}

function* countrystatesSaga() {
  yield takeEvery("countryStateSlice/getCountriesApi",getCountriesApi);
  yield takeEvery("countryStateSlice/getStatesFromApi", getStates);
}
export default countrystatesSaga;